import { combineReducers } from 'redux';

import IssueTypeDataReducer from './IssueTypes/IssueTypes';
import SelectedIssueDataReducer from './SelectedIssue/SelectedIssue';

export default combineReducers({
    issueTypes: IssueTypeDataReducer,
    selectedIssue: SelectedIssueDataReducer
});
